export const DownloadResultStyles = {
    container: "bg-white rounded-lg shadow-iw flex flex-col flex-grow h-fit items-center justify-center"
}